export default {
    name: 'exercise',
    props: ['purchased_id', 'resource_id', 'exercise_num', 'edit', 'instructorComment', 'grade'],
    data() {
        return {
            // //订单项id
            // purchased_id:'',
            // // 资源id
            // resource_id:'',
            //输入框
            textarea: '',
            // 课后习题问题
            exerciseContent: '',
            // 课后习题标题
            exerciseContentName: '',
            //是否提交答案标志
            textareaBz: false,
			Imgurl: require('../../assets/images/avatar.jpg'),
			exerciseContentText:''

        }
    },

    methods: {
        // 请求课后习题资源
        getData() {
            this.$post('resources/get', {
                token: this.$store.state.id,
                id: this.resource_id
            }).then(res => {
                // // console.log('课后习题',res.data)
                this.exerciseContent = res.data.result.data
                this.exerciseContentName = res.data.result.name
            })
        },
        //获取提交内容 判断是否提交答案
        getSubmissions() {
            this.$post('private/get', {
                token: this.$store.state.id,
                resource_id: this.resource_id,
                purchased_id: this.purchased_id
            }).then(res => {
				
                // 学员已经提交了课后习题的答案
                if (res.data.result != null) {
                    this.private_id = res.data.result.id
                }

                 console.log('获取提交内容',res)
				
                if (res.data.result && res.data.result.content) {
					this.exerciseContentText = res.data.result.content
                    this.textarea = res.data.result.content
                    this.textareaBz = false//编辑栏不可输入
                    console.log(1)
                } else {
                    this.textareaBz = true//编辑栏可以正常输入
                    console.log(2)
                }
            })
        },

        // 提交课后习题资源
        postData() {

            // private_id有值，学员已经提交过课后习题的答案，再点提交就是更新习题了
            if (this.private_id) {
                this.$post('private/update_content', {
                    token: this.$store.state.id,
                    id: this.private_id,
                    content: this.textarea
                }).then(res => {
					// console.log(res)
					this.getSubmissions()
                    if (res.status === 200) {
                        this.$message({
                            message: '更新成功',
                            type: 'success'
                        })
                        this.$emit('exerciseMain', 2); // 向父组件传值
                    }
                })
            }else{
				this.$post('private/create', {
				    token: this.$store.state.id,
				    content: this.textarea,
				    resource_id: this.resource_id,
				    purchased_id: this.purchased_id
				}).then(res => {
					this.getSubmissions()
				    if (res.data.status == "success") {
				        this.$message({
				            message: '提交成功',
				            type: 'success'
				        });
				        this.textareaBz = false//编辑栏不可输入
				        this.$emit('exerciseMain', 2);//向父组件传值
				    } else {
				        this.$message.error('提交失败');
				    }
				})
			}

            
        },

        //提交按钮事件
        BtnSubmit() {
            if (this.jiaoyan(this.exercise_num)) {
                this.postData()
            }
        },

        //取消按钮事件
        BtnCancel() {
            this.textarea = ""
        },

        // 检验提交内容
        jiaoyan(num) {
            num ? num : num = 15
            if (!this.textarea) {
                this.$message.error('内容不能为空！');
                return false
            }
            if (this.textarea.length < num) {
                this.$message.error("内容不能少于" + num + "个字！");
                return false
            }
            return true
        },



    },

    created() {
        this.getData();
        this.getSubmissions()
    },

    mounted() {
        // // console.log('purchased_id',this.purchased_id)
        // // console.log('purchased_id',this.resource_id)
    }
}